import { useMemo } from "react";
import { PRACTICE_AREA, sessionTermFor } from "../domain/user.domain";
import { useAppSelector } from "./redux-hooks";

/**
 * Custom hook that determines the individual reference type (Patient vs Client)
 * based on the user's specialty from userInfo
 */
const specialityWithReferenceAsPatient: string[] = ["psychiatrist", "pmhnp"];
export const useSpecialityReference = () => {
  const userInfo = useAppSelector((state) => state.auth.userInfo);
  const shouldReferAsPatient = useMemo(() => {
    return (
      userInfo.practice_area === PRACTICE_AREA.MEDICINE ||
      specialityWithReferenceAsPatient.includes(userInfo.specialty_code || "")
    );
  }, [userInfo.practice_area, userInfo.specialty_code]);

  const referIndividualBy = useMemo(() => {
    const specialty = userInfo.specialty_code || "";

    if (specialityWithReferenceAsPatient.includes(specialty) || userInfo.practice_area === PRACTICE_AREA.MEDICINE) {
      return "Patient";
    }

    return "Client";
  }, [userInfo.specialty_label, userInfo.specialty_code, userInfo.practice_area]);

  const sessionTerm = sessionTermFor(shouldReferAsPatient);
  const sessionTermLower = sessionTerm.toLowerCase();

  return { referIndividualBy, shouldReferAsPatient, sessionTerm, sessionTermLower };
};

export default useSpecialityReference;
